<!-- 监测床位详情 -->
<template>
  <div class="content">
    <div class="timeX" v-if="formBG == ''">
      <p>10分钟-</p>
      <p>5分钟-</p>
      <p style="margin-bottom:33px;">0分钟-</p>
    </div>
    <div v-else class="timeX">
      <p>10</p>
      <p>5</p>
      <p style="margin-bottom:0;">0</p>
    </div>
    <div class="box">
      <div class="box-column">
        <div class="column-con">
          <div
            class="column"
            v-for="(item, index) in activeTimeArr"
            :key="index"
            @mouseenter="mouseenter"
            @mouseleave="mouseleave"
            :data-index="index"
          >
            <div
              class="item"
              :style="{ background: item.data.color[ind] }"
              v-for="(jtem, ind) in item.data.data"
              :key="ind"
              @mouseenter="mouseenterFormCon"
              :data-index="ind"
            ></div>
          </div>
        </div>
        <div class="time-column-point" v-if="formBG === ''">
          <div v-for="(ktem, index2) in timeArr" :key="index2">
            <span v-if="ktem.time.slice(-2) === '00'" class="Xtime">
              {{ ktem.time }}
            </span>
          </div>
          <div class="time-start">{{ domBeginTime }}</div>
          <div class="time-end" :style="{ left: positionLeft + 'px' }">
            {{ domEndTime }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="showDialog"
      class="dialog"
      :style="{ left: pageX + 'px', top: pageY + 'px' }"
    >
      <div>{{ beginTime }} ~ {{ endTime }}</div>
      <div v-if="showDialogText">{{ dialogText }}</div>
      <div v-else>
        <div>离线</div>
        <div>请检查电源和</div>
        <div>网络情况</div>
      </div>
    </div>
  </div>
</template>

<script>
import { createGlobalStompScope } from '@/utils/stomp';

export default {
  name: 'pieCom',
  props: {
    formBG: {
      type: String,
      default: '',
    },
    timeArrData: {
      type: Array,
      default: () => [],
    },
    bedId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      beginTime: '',
      endTime: '',
      pageX: 0,
      pageY: 0,
      showDialog: false,
      showDialogText: true,
      dialogText: '有人',
      copyData: [],
      flagToContext: 1,
      activeTimeArr: [],
      times: null,
      domBeginTime: '',
      domEndTime: '',
      timeArr: [],
      requestCun: 1,
      positionLeft: 905,
      scrollDom: [],
      stompClient: null,
    };
  },
  created() {
    if (this.formBG == '') {
      this.getDetailDataToPart();
    }
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.timeArr = this.timeArrData;
    this.activeTimeArr = this.timeArrData;
    this.scrollDom = document.getElementsByClassName('box');
    this.scrollDom[0].scrollTo(0, 1000000000);
    document
      .querySelector('.box')
      .addEventListener('scroll', this.handleScroll);
    this.getSocketPart();
  },
  methods: {
    getDetailDataToPart(
      dataTime = '',
      direction = '',
      beforeHourse = '',
      clear = ''
    ) {
      let params = {
        nextHourTime: dataTime,
        direction: direction,
        beforeHourse: beforeHourse,
        bedId: this.$route.query.id || this.bedId,
      };
      if (clear) {
        this.timeArr = [];
      }
      this.$get(
        '/api/fall/part/getFallPartInfo',
        params,
        (res) => {
          if (res.code == 0) {
            this.$emit('transfer', res.data.fallPicData[0].date);
            this.timeArr.unshift(...res.data.fallPicData);
            this.activeTimeArr = this.timeArr;
            this.domBeginTime = this.timeArr[0].time;
            if (dataTime) {
              if (clear) {
                this.positionLeft = beforeHourse * 66 - 17;
              } else {
                this.positionLeft += 793 + 132;
              }

              this.scrollDom[0].scrollLeft = 132;
            }
            setTimeout(() => {
              this.requestCun++;
            }, 1000);
            if (
              +this.timeArr[this.timeArr.length - 1].time.slice(3) + 10 ===
              60
            ) {
              +this.timeArr[this.timeArr.length - 1].time.slice(0, 2) + 1;
              if (
                +this.timeArr[this.timeArr.length - 1].time.slice(0, 2) + 1 ===
                24
              ) {
                this.domEndTime = '00:00';
              } else {
                this.domEndTime =
                  +this.timeArr[this.timeArr.length - 1].time.slice(0, 2) +
                  1 +
                  ':00';
              }
            } else {
              this.domEndTime =
                this.timeArr[this.timeArr.length - 1].time.slice(0, 3) +
                (+this.timeArr[this.timeArr.length - 1].time.slice(3) + 10);
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getSocketPart() {
      let bedId = this.$route.query.id || this.bedId;
      if (this.stompClient) {
        this.stompClient.destroy();
        this.stompClient = null;
      }
        this.stompClient = createGlobalStompScope({
          vm: this,
          name: 'toilet-pie-fall-part',
      });
      this.stompClient.subscribe('/topic/bedFallPart.' + bedId, () => {
        this.getDetailDataToPart();
        this.positionLeft = 905;
        this.timeArr = [];
        this.scrollDom[0].scrollLeft = 1000000000000000;
        this.$emit('transfer', this.timeArr[40].date);
      });
      this.stompClient.connect();
    },
    getCookie(c_name) {
      var name = c_name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i].trim()); // 解码
        if (c.indexOf(name) == 0) {
          return JSON.parse(c.substring(name.length, c.length));
        }
      }
      return '';
    },
    handleScroll(e) {
      if (this.requestCun == 1) {
        return;
      }
      let startIndex = parseInt(e.target.scrollLeft / 11) + 40;
      this.$emit('transfer', this.timeArr[startIndex].date);
      if (this.times) {
        clearTimeout(this.times);
      }
      this.times = setTimeout(() => {
        //调用接口

        if (e.target.scrollLeft < 40) {
          this.getPieData();
        }
      }, 500);
    },
    getPieData() {
      this.requestCun++;
      let dataTime = this.timeArr[0].date + ' ' + this.timeArr[0].time + ':00'; //    起始时间
      let direction = 1; //查找方向
      let beforeHourse = 14; //查找时间
      this.getDetailDataToPart(dataTime, direction, beforeHourse);
    },
    mouseenter(e) {
      this.showDialog = true;
      this.columnFlag = +e.target.dataset.index; // 大柱自定义属性de
      this.activeTimeArr[this.columnFlag]['data'].data.forEach(
        (item, index) => {
          this.activeTimeArr[this.columnFlag]['data'].color.splice(
            index,
            1,
            '#EBF8FF'
          );
        }
      );
    },
    mouseleave() {
      this.showDialog = false;
      this.activeTimeArr.forEach((item) => {
        item.data.data.forEach((jtem, ind) => {
          if (jtem === 0) {
            item.data.color.splice(ind, 1, '#f5f5f5');
          } else if (jtem === 1) {
            item.data.color.splice(ind, 1, '#52C41A');
          } else if (jtem === 2) {
            item.data.color.splice(ind, 1, '#D9D9D9');
          } else if (jtem === 9) {
            item.data.color.splice(ind, 1, '#fff');
          } else if (jtem === 3) {
            item.data.color.splice(ind, 1, '#FF7186');
          }
        });
      });
    },
    mouseenterFormCon(e) {
      this.showDialog = true;
      console.log(e);
      this.pageX = e.clientX;
      this.pageY = e.clientY;
      let index = e.target.dataset.index;
      this.flagToContext = this.timeArr[this.columnFlag].data.data[index];
      if (this.timeArr[this.columnFlag].data.data[index] === 0) {
        this.showDialog = false;
        this.timeArr[this.columnFlag].data.data.forEach((item, ind) => {
          if (item === 0) {
            this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#EBF8FF');
          } else if (item === 1) {
            this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#52C41A');
          } else if (item === 2) {
            this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#D9D9D9');
          } else if (item === 9) {
            this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#fff');
          } else if (item === 3) {
            this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#fd8697');
          }
        });
      }
      if (
        this.timeArr[this.columnFlag].data.data[index] === 1 ||
        this.timeArr[this.columnFlag].data.data[index] === 9 ||
        this.timeArr[this.columnFlag].data.data[index] === 3
      ) {
        this.showDialogText = true;
        if (this.timeArr[this.columnFlag].data.data[index] === 1) {
          this.dialogText = '有人';
        } else if (this.timeArr[this.columnFlag].data.data[index] === 9) {
          this.dialogText = '暂无数据';
        } else if (this.timeArr[this.columnFlag].data.data[index] === 3) {
          this.dialogText = '有人跌倒';
        }
      } else if (this.timeArr[this.columnFlag].data.data[index] === 2) {
        this.showDialogText = false;
      }
      this.timeArr[this.columnFlag].data.data.forEach((item, ind) => {
        if (item === 0) {
          this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#f5f5f5');
        } else if (item === 1) {
          this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#52C41A');
        } else if (item === 2) {
          this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#D9D9D9');
        } else if (item === 9) {
          this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#fff');
        } else if (item === 3) {
          this.timeArr[this.columnFlag].data.color.splice(ind, 1, '#fd8697');
        }
      });
      this.computeEndTime(this.columnFlag, +index, this.flagToContext);
      this.computeBeginTime(this.columnFlag, +index, this.flagToContext);
    },
    computeBeginTime(columnFlag, flagToInd, flagToContext) {
      if (columnFlag == 0 && flagToInd == 9) {
        if (this.timeArr[columnFlag].data.data[flagToInd] == flagToContext) {
          this.beginTime = this.timeArr[columnFlag].time;
          return false;
        }
      }
      if (this.timeArr[columnFlag].data.data[flagToInd] !== flagToContext) {
        let flagToConBegin = 10 - flagToInd;
        let minStr;
        let sliceTime = +this.timeArr[columnFlag].time.slice(-2);
        minStr = flagToConBegin;
        minStr = sliceTime + minStr;
        if (minStr < 10) {
          minStr = '0' + minStr;
        }
        if (minStr === 60) {
          minStr = '00';
          let timeHeard = +this.timeArr[columnFlag].time.slice(0, 2);
          if (timeHeard < 24) {
            timeHeard = timeHeard + 1;
            if (timeHeard === 24) {
              timeHeard = '00';
            }
          }
          this.beginTime = timeHeard + ':' + minStr;
        } else {
          this.beginTime =
            this.activeTimeArr[columnFlag].time.slice(0, 3) + minStr;
        }
        return false;
      }
      this.timeArr[columnFlag].data.data.forEach((item, ind) => {
        if (item === 0) {
          this.timeArr[columnFlag].data.color.splice(ind, 1, '#EBF8FF');
        } else if (item === 9) {
          this.timeArr[columnFlag].data.color.splice(ind, 1, '#fff');
        }
      });
      if (this.timeArr[columnFlag]['data'].data[flagToInd] == 0) {
        this.activeTimeArr[columnFlag]['data'].color.splice(
          flagToInd,
          1,
          '#EBF8FF'
        );
      } else if (this.timeArr[columnFlag]['data'].data[flagToInd] == 1) {
        this.activeTimeArr[columnFlag]['data'].color.splice(
          flagToInd,
          1,
          '#A2E780'
        );
      } else if (this.timeArr[columnFlag]['data'].data[flagToInd] == 2) {
        this.activeTimeArr[columnFlag]['data'].color.splice(
          flagToInd,
          1,
          '#E3E3E3'
        );
      } else if (this.timeArr[columnFlag]['data'].data[flagToInd] == 9) {
        console.log(9999999);
        this.activeTimeArr[columnFlag]['data'].color.splice(
          flagToInd,
          1,
          '#fff'
        );
      }
      let flagToConBegin = flagToInd; // 大柱中的每一个小柱用于向前找
      let timeData;
      if (columnFlag < 0) {
        //超过最大数组长度显示结束时间
        this.endTime = this.activeTimeArr[0].time;
        return false;
      } else {
        timeData = [...this.timeArr[columnFlag]['data'].data];
      }
      if (timeData[flagToConBegin] == flagToContext) {
        // 递归查找开始时间
        if (flagToInd == 9) {
          flagToInd = -1;
          columnFlag = columnFlag - 1;
        }
        this.computeBeginTime(columnFlag, flagToInd + 1, this.flagToContext);
      } else {
        flagToConBegin = 10 - flagToConBegin;
        let minStr;
        let sliceTime = +this.timeArr[columnFlag].time.slice(-2);
        minStr = flagToConBegin;
        minStr = sliceTime + minStr;
        if (minStr < 10) {
          minStr = '0' + minStr;
        }
        if (minStr === 60) {
          minStr = '00';
          let timeHeard = +this.timeArr[columnFlag].time.slice(0, 2);
          if (timeHeard < 24) {
            timeHeard = timeHeard + 1;
            if (timeHeard === 24) {
              timeHeard = '00';
            }
          }
          this.beginTime = timeHeard + ':' + minStr;
        } else {
          this.beginTime =
            this.activeTimeArr[columnFlag].time.slice(0, 3) + minStr;
        }
      }
    },
    computeEndTime(columnFlag, flagToInd, flagToContext) {
      if (columnFlag == this.timeArr.length - 1 && flagToInd == 0) {
        if (flagToContext == 1) {
          this.activeTimeArr[columnFlag]['data'].color.splice(
            flagToInd,
            1,
            '#A2E780'
          );
        } else if (flagToContext == 2) {
          this.activeTimeArr[columnFlag]['data'].color.splice(
            flagToInd,
            1,
            '#e3e3e3'
          );
        } else if (flagToContext == 9) {
          this.activeTimeArr[columnFlag]['data'].color.splice(
            flagToInd,
            1,
            '#fff'
          );
        } else {
          this.activeTimeArr[columnFlag]['data'].color.splice(
            flagToInd,
            1,
            '#f5f5f5'
          );
        }
        if (this.timeArr[columnFlag].data.data[flagToInd] == flagToContext) {
          let minStr;
          let sliceTime = +this.timeArr[columnFlag].time.slice(-2);
          minStr = 10;
          minStr = sliceTime + minStr;
          if (minStr < 10) {
            minStr = '0' + minStr;
          }
          if (minStr === 60) {
            minStr = '00';
            let timeHeard = +this.timeArr[columnFlag].time.slice(0, 2);
            if (timeHeard < 24) {
              timeHeard = timeHeard + 1;
              if (timeHeard === 24) {
                timeHeard = '00';
              }
            }
            this.endTime = timeHeard + ':' + minStr;
          } else {
            this.endTime =
              this.activeTimeArr[columnFlag].time.slice(0, 3) + minStr;
          }
          return false;
        }
      }
      if (this.timeArr[columnFlag].data.data[flagToInd] !== flagToContext) {
        let flagToConAfter = flagToInd + 1;
        let minStr;
        let sliceTime = +this.timeArr[columnFlag].time.slice(-2);
        minStr = 10 - flagToConAfter;
        minStr = sliceTime + minStr;
        if (minStr < 10) {
          minStr = '0' + minStr;
        }
        if (minStr === 60) {
          minStr = '00';
          let timeHeard = +this.timeArr[columnFlag].time.slice(0, 2);
          if (timeHeard < 24) {
            timeHeard = timeHeard + 1;
            if (timeHeard === 24) {
              timeHeard = '00';
            }
          }
          this.endTime = timeHeard + ':' + minStr;
        } else {
          this.endTime =
            this.activeTimeArr[columnFlag].time.slice(0, 3) + minStr;
        }
        return false;
      }
      let subNum = columnFlag === this.activeTimeArr.length ? 1 : 0;
      if (this.timeArr[columnFlag - subNum]['data'].data[flagToInd] == 0) {
        if (columnFlag !== this.columnFlag && flagToInd == 9) {
          this.activeTimeArr[columnFlag - subNum]['data'].color.splice(
            flagToInd,
            1,
            '#EBF8FF'
          );
        } else {
          this.activeTimeArr[columnFlag - subNum]['data'].color.splice(
            flagToInd,
            1,
            '#EBF8FF'
          );
        }
      } else if (
        this.activeTimeArr[columnFlag - subNum]['data'].data[flagToInd] == 1
      ) {
        this.activeTimeArr[columnFlag - subNum]['data'].color.splice(
          flagToInd,
          1,
          '#A2E780'
        );
      } else if (
        this.activeTimeArr[columnFlag - subNum]['data'].data[flagToInd] == 2
      ) {
        this.activeTimeArr[columnFlag - subNum]['data'].color.splice(
          flagToInd,
          1,
          '#E3E3E3'
        );
      }

      let flagToConAfter = flagToInd; // 大柱中的每一个小柱用于向后找
      let flagToConBegin = flagToInd; // 大柱中的每一个小柱用于向前找
      let timeData;
      if (columnFlag === this.activeTimeArr.length) {
        //超过最大数组长度显示结束时间
        let timeHeard = +this.timeArr[columnFlag - 1].time.slice(0, 2);
        if (timeHeard < 24) {
          timeHeard = timeHeard + 1;
          if (timeHeard === 24) {
            timeHeard = '00';
          }
        }
        this.endTime = timeHeard + ':' + '00';
        return false;
      } else {
        timeData = [...this.timeArr[columnFlag].data.data];
      }
      if (timeData[flagToConAfter] == flagToContext) {
        // 递归查找结束时间
        if (flagToInd == 0) {
          flagToInd = 10;
          columnFlag = columnFlag + 1;
        }
        this.computeEndTime(columnFlag, flagToInd - 1, this.flagToContext);
      } else {
        flagToConAfter = flagToConAfter + 1;
        let minStr;
        let sliceTime = +this.timeArr[columnFlag].time.slice(-2);
        minStr = 10 - flagToConAfter;
        minStr = sliceTime + minStr;
        if (minStr < 10) {
          minStr = '0' + minStr;
        }
        if (minStr === 60) {
          minStr = '00';
          let timeHeard = +this.timeArr[columnFlag].time.slice(0, 2);
          if (timeHeard < 24) {
            timeHeard = timeHeard + 1;
            if (timeHeard === 24) {
              timeHeard = '00';
            }
          }
          this.endTime = timeHeard + ':' + minStr;
        } else {
          this.endTime =
            this.activeTimeArr[columnFlag].time.slice(0, 3) + minStr;
        }
      }
    },
  },
  beforeDestroy() {
    if (this.stompClient) {
      this.stompClient.destroy();
      this.stompClient = null;
    }
  },
};
</script>
<style scoped lang="scss">
.pic {
  margin-top: 20px;
  width: 900px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .content {
    width: 900px;
    height: 190px;
    display: flex;
    position: relative;
    left: -5px;
    .timeX {
      border-right: 1px solid #ccc;
      height: 150px;
      text-align: right;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-between;
      p {
        width: 50px;
      }
    }
    .box {
      position: relative;
      width: 800px;
      height: 200px;
      overflow-x: scroll;
    }
    .box-column {
      height: 180px;
      position: relative;
      .column-con {
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .column {
        flex-shrink: 0;
        width: 10px;
        background: #f5f5f5;
        height: 150px;
        margin-left: 1px;
        float: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;
        .item {
          height: 15px;
        }
        .has-people-item {
          background: #52c41a;
        }
      }
    }
    .time-column {
      font-size: 12px;
      display: flex;
      align-items: center;
      margin-left: -15px;
      justify-content: space-between;
      .times {
        margin-left: -10px;
      }
    }
    .time-column-point {
      font-size: 12px;
      display: flex;
      position: relative;

      div {
        display: inline-block;
      }
      div:first-of-type {
        .Xtime {
          margin-left: 0;
          opacity: 0;
        }
      }
      .time-start {
        font-size: 12px;
        position: absolute;
        bottom: -10px;
        left: 0;
      }
      .time-end {
        font-size: 12px;
        position: absolute;
        bottom: -10px;
        left: 905px;
      }
      .time-start::before {
        position: absolute;
        top: -10px;
        left: 0;
        content: '';
        height: 10px;
        width: 1px;
        background: #262626;
      }
      .time-start::after {
        position: absolute;
        top: -10px;
        left: 33px;
        content: '';
        height: 10px;
        width: 1px;
        background: #262626;
      }
      .time-end::after {
        position: absolute;
        top: -10px;
        left: 17px;
        content: '';
        height: 10px;
        width: 1px;
        background: #262626;
      }
      .Xtime {
        position: relative;
        top: 10px;
        left: -15px;
        display: inline-block;
        width: 30px;
        margin-left: 36px;
      }

      .Xtime::before {
        position: absolute;
        top: -10px;
        left: 15px;
        content: '';
        height: 10px;
        width: 1px;
        background: #262626;
      }
      .Xtime::after {
        position: absolute;
        top: -10px;
        left: 50px;
        content: '';
        height: 10px;
        width: 1px;
        background: #262626;
      }
    }
    .dialog {
      position: fixed;
      width: 130px;
      padding: 12px 10px;
      background: rgba(255, 255, 255, 0.7);
      box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      border: 1px solid #1890ff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      z-index: 100;
    }
  }
}
</style>
